module.exports = __webpack_public_path__ + "static/media/04.bce2bec4.jpg";